import React from 'react';
import Hero from '../components/Hero';
import styled from 'styled-components';
import TestimonialCard from '../components/TestimonialCard';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


const ServicesWrapper = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px; /* Increased gap for cleaner layout */
  padding: 60px 40px;
  background-color: ${({ theme }) => theme.colors.background};
  justify-items: center;
`;

const ServiceCardStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.white}; /* Light background for contrast */
  border-radius: 12px; /* Rounded corners for a modern look */
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
  padding: 30px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  max-width: 350px;
  min-height: 280px; /* Minimum height for uniformity */

  &:hover {
    transform: translateY(-10px); /* Lift effect on hover */
    box-shadow: 0 12px 25px rgba(0, 0, 0, 0.2); /* Stronger shadow on hover */
  }
`;

const ServiceTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary}; /* Accent color */
  margin-bottom: 10px;
`;

const ServiceDescription = styled.p`
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 0;
  line-height: 1.6;
`;

const TestimonialSection = styled.section`
  background-color: #f9f9f9;
  padding: 60px 0;
`;

const TestimonialHeading = styled.h2`
  text-align: center;
  font-size: 2.2rem;
  margin-bottom: 40px;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 700;
`;

const CarouselContainer = styled.div`
  max-width: 1200px; /* limit total width */
  margin: 0 auto;    /* center the carousel container */
  padding: 0 40px;   /* horizontal padding */

  /* Spacing around slides */
  .slick-slide {
    padding: 0 10px;
  }

  /* Dots styling */
  .slick-dots li button:before {
    color: #aaa;
    font-size: 10px; /* slightly smaller dots */
  }
  .slick-dots li.slick-active button:before {
    color: ${({ theme }) => theme.colors.primary};
  }

  /* Arrow styling */
  .slick-prev:before,
  .slick-next:before {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 20px;
  }
`;

const Home = () => {
  // Slick slider settings
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,    // 3 cards per view on desktop
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024, // below 1024px
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600, // below 600px
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div>
      <Hero />
      {/* Services Section */}
      <ServicesWrapper>
        <ServiceCardStyled>
          <ServiceTitle>AWS Consulting</ServiceTitle>
          <ServiceDescription>
            Leverage our expertise in AWS to optimize your cloud infrastructure, reduce costs, and improve scalability.
          </ServiceDescription>
        </ServiceCardStyled>
        <ServiceCardStyled>
          <ServiceTitle>Azure Consulting</ServiceTitle>
          <ServiceDescription>
            Tailored Azure solutions designed to meet your business needs, from hybrid cloud setups to advanced AI integrations.
          </ServiceDescription>
        </ServiceCardStyled>
        <ServiceCardStyled>
          <ServiceTitle>Google Cloud Consulting</ServiceTitle>
          <ServiceDescription>
            Harness the power of Google Cloud with our innovative strategies for cloud-native development and big data analytics.
          </ServiceDescription>
        </ServiceCardStyled>
      </ServicesWrapper>

      {/* Testimonials Section */}
      <TestimonialSection>
        <TestimonialHeading>Testimonials</TestimonialHeading>
        <CarouselContainer>
          <Slider {...settings}>
            <TestimonialCard
              quote="I had the pleasure of working with Cloudetica Solutions on a critical AWS project and Renaldi delivered, with exceptional results. He showcased an expert-level understanding of AWS services, addressing and providing solutions to our complex issues, and optimizing our infrastructure for future scalability and efficiency. His ability to clearly communicate technical concepts was impressive, delivering quality work with high professionalism. If you're seeking a skilled and reliable AWS expert, Renaldi is your man!"
              author="Tes"
            />
            <TestimonialCard
              quote="Renaldi, and his company Cloudetica, demonstrated expert knowledge of my AWS MFA problems, and lead me through the detailed required steps to solve these problems. Small companies like my Beneficial Machine Tools LLC absolutely need expert people like Renaldi to be successful."
              author="George, Beneficial Machine Tools LLC"
            />
            <TestimonialCard
              quote="Renaldi exceeded all expectations by delivering the project ahead of schedule and under budget. His professionalism and responsiveness were impressive, and he quickly adapted and onboarded himself without issue. I highly recommend working with him. Renaldi tackled the challenge of compiling a complex C++ project with ease and even went the extra mile by providing a straightforward method for me to validate his work. His commitment and expertise truly set him apart!"
              author="Daniel Habib"
            />
            <TestimonialCard
              quote="Renaldi created a detailed hardening guide for our server, addressing all requests and covering every topic thoroughly. He demonstrates strong cybersecurity expertise and consistently exceeds expectations, paired with outstanding communication skills. This very rare combination makes him a pleasure to work with. We look forward to collaborating with him again and highly recommend his services."
              author="Cambrian Investment"
            />
            <TestimonialCard
              quote="I had a great experience working with Cloudetica Solutions. They are highly responsible and go the extra mile to explain their work process, helping us understand any issues along the way. We highly recommend working with them."
              author="ArtBatLive"
            />
            <TestimonialCard
              quote="Cloudetica Solutions helped me migrate my on-premises .NET-based architecture to AWS, providing clarity and direction when needed. I appreciated the timely support for this big task."
              author="Alex, Tech Lead"
            />
          </Slider>
        </CarouselContainer>
      </TestimonialSection>
    </div>
  );
};

export default Home;
